const debug = process.env.REACT_APP_DEBUG && false;
export const sumamrizeVobList = (vobs, maxLength = 10) => {
    const base = `Selected items; ${vobs.length}`;
    const firstN = vobs.slice(0, maxLength);
    const names = `${firstN.map((x) => x.name).join(', ')}`;
    const last = vobs.slice(maxLength);
    return `${base}: ${names}${last.length > 0 ? ` and ${last.length} other${last.length > 1 ? 's' : ''}.` : ''}`;
};
export const defaulColumnVisibilityModel = {
    select: true,
    type: true,
    name: true,
    description: true,
};
export var PaginationMode;
(function (PaginationMode) {
    PaginationMode["SERVER"] = "server";
    PaginationMode["CLIENT"] = "client";
})(PaginationMode || (PaginationMode = {}));
export const getClassDefaultColumnVisibilityModel = (providedModel) => {
    const model = { ...defaulColumnVisibilityModel };
    Object.assign(model, providedModel);
    return model;
};
